$(document).ready(function () {

    //card product hover

    (function () {

        let product = $('.card-product');

        if (product.length) {

            product.each(function (index) {

                product.eq(index).hover(function () {

                    product.eq(index).addClass('current').css('z-index', '4');


                }, function () {

                    setTimeout(function () {

                        product.eq(index).removeClass('current');

                    }, 150);

                    product.eq(index).removeAttr('style');

                });

            });

        }

    })();

});


// WEBPACK FOOTER //
// ./scripts/rent.js